import { RESET_ORDER, SET_ORDER } from './order-actions';

export const setOrder = (data) => dispatch => {
    dispatch({
        type: SET_ORDER,
        payload: { data }
    });
};

export const resetOrder = (data) => dispatch => {
    dispatch({
        type: RESET_ORDER
    });
};